<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (ngModelChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.categories' | transloco }}</small>
              <hx-product-category-select [(ngModel)]="params.categoryIds" [multiple]="true" [brandId]="brandId" (ngModelChange)="navigate()"></hx-product-category-select>
            </div>
          </div>
          <button type="button" *ngIf="params.storeIds" (click)="generate()" class="btn btn-outline-success m--margin-top-15 m--margin-right-10"
                  [disabled]="isLoading.generate" [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.generate}">
            {{ 'download' | transloco }}
          </button>

          <button type="button" (click)="resetFilter()" class="btn btn-outline-primary m--margin-top-15">
            {{ 'reset.list' | transloco }}
          </button>

          <div class="m-content-tab">
            <div class="row">
              <ul ngbNav [(activeId)]="activeNav" (activeIdChange)="onTabChanged()" #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
                <li [ngbNavItem]="'report'">
                  <a ngbNavLink>{{ 'user.report' | transloco }}</a>
                  <ng-template ngbNavContent>
                    <div *ngIf="list.length && !isLoading.list" class="block-table-scroll">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-head-one" rowspan="2">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one" colSpan="2">{{ 'revenue-report.table.head.total' | transloco }}</th>
                          <th *ngFor="let cmn of list[0].storeStats" class="text-center" colspan="3">
                            {{ cmn.storeName | uiLabel }}
                          </th>
                        </tr>
                        <tr class="fixed-head-tline">
                          <th class="fixed-head-tline">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="fixed-head-tline">{{ 'revenue-report.table.head.sum' | transloco }}</th>
                          <ng-container *ngFor="let cmn of list[0].storeStats">
                            <th class="text-align-center">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                            <th class="text-align-center">{{ 'revenue-report.table.head.sum' | transloco }}</th>
                            <th class="text-align-center">%</th>
                          </ng-container>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let productRevenue of list">
                          <tr>
                            <td>{{ productRevenue.productName | uiLabel }}</td>
                            <td class="text-align-center">{{ productRevenue.totalAmount }}</td>
                            <td class="text-align-center">{{ productRevenue.totalSum }}</td>
                            <ng-container *ngFor="let pt of productRevenue.storeStats">
                              <td class="text-align-center">{{ pt.amount }}</td>
                              <td class="text-align-center">{{ pt.sum }}</td>
                              <td class="text-align-center percent-color">{{ pt.percent }}</td>
                            </ng-container>
                          </tr>
                        </ng-container>
                        </tbody>
                      </table>
                    </div>
                    <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
                  </ng-template>
                </li>

                <li [ngbNavItem]="'report1'">
                  <a ngbNavLink>{{ 'user.report1' | transloco }}</a>
                  <ng-template ngbNavContent>
                    <div *ngIf="listCategory.length && !isLoading.category" class="tables-wrapper">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">%</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let cat of listCategory">
                          <tr>
                            <td>{{ cat.categoryTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ cat.percentOfTotalAmount }}</td>
                            <td class="text-align-center">{{ cat.totalAmountCategory }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center">Итого</td>
                          <td class="text-align-center">
                          </td>
                          <td class="text-align-center">
                            {{ listCategory[0].totalAmountAll }}
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">%</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let cat of listCategory">
                          <tr>
                            <td>{{ cat.categoryTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ cat.percentOfTotal }}</td>
                            <td class="text-align-center">{{ cat.totalCategory }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center">Итого</td>
                          <td class="text-align-center">
                          </td>
                          <td class="text-align-center">
                            {{ listCategory[0].totalAll }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <table class="m--margin-top-10 m--margin-bottom-40" *ngIf="listDiscarded.length && !isLoading.discard">
                      <thead>
                      <tr>
                        <th class="text-center">СПИСАНИЕ</th>
                        <th class="text-center">Кол-во</th>
                        <th class="text-center">Сумма</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>
                          <!-- Генерация списка через ; -->
                          <ng-container *ngFor="let cat of listDiscarded; let last = last">
                            {{ cat.categoryTitle | uiLabel }}
                            ({{ cat.totalAmountCategory > 0 ? cat.totalAmountCategory : 0 }} шт)<ng-container *ngIf="!last">; </ng-container>
                          </ng-container>
                        </td>
                        <td class="text-center">
                          {{ discardTotalAmount }}
                        </td>
                        <td class="text-center">
                          {{ discardTotalValue | moneyFormat }}
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <div *ngIf="listStandardAndMaxCakesCount.length && listStandardAndMaxCakesValue.length && !isLoading.product" class="tables-wrapper block-table-scroll">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listStandardAndMaxCakesCount">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalStandardAndMaxCakesCount }}</td>
                          <td class="text-align-center">{{ totalStandardAndMaxCakesValue }}</td>
                        </tr>
                        </tbody>
                      </table>

                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listStandardAndMaxCakesValue">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalStandardAndMaxCakesCount }}</td>
                          <td class="text-align-center">{{ totalStandardAndMaxCakesValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div *ngIf="listServicesSortCount.length && listServicesSortValue.length && !isLoading.product" class="tables-wrapper block-table-scroll">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listServicesSortCount">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalServicesCount }}</td>
                          <td class="text-align-center">{{ totalServicesValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listServicesSortValue">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalServicesCount }}</td>
                          <td class="text-align-center">{{ totalServicesValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div *ngIf="listNotStandardCakesCount.length && listNotStandardCakesValue.length && !isLoading.product" class="tables-wrapper block-table-scroll">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listNotStandardCakesCount">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalNotStandardCakesCount }}</td>
                          <td class="text-align-center">{{ totalNotStandardCakesValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listNotStandardCakesValue">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalNotStandardCakesCount }}</td>
                          <td class="text-align-center">{{ totalNotStandardCakesValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div *ngIf="listOtherCakesCount.length && listOtherCakesValue.length && !isLoading.product" class="tables-wrapper block-table-scroll">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listOtherCakesCount">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalOtherCakesCount }}</td>
                          <td class="text-align-center">{{ totalOtherCakesValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listOtherCakesValue">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalOtherCakesCount }}</td>
                          <td class="text-align-center">{{ totalOtherCakesValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div *ngIf="listAdditionalNomenclatureCount.length && listAdditionalNomenclatureValue.length && !isLoading.product" class="tables-wrapper block-table-scroll">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listAdditionalNomenclatureCount">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalAdditionalNomenclatureCount }}</td>
                          <td class="text-align-center">{{ totalAdditionalNomenclatureValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listAdditionalNomenclatureValue">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalAdditionalNomenclatureCount }}</td>
                          <td class="text-align-center">{{ totalAdditionalNomenclatureValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div *ngIf="listOthersCount.length && listOthersValue.length && !isLoading.product" class="tables-wrapper block-table-scroll">
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listOthersCount">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalOthersCount }}</td>
                          <td class="text-align-center">{{ totalOthersValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table class="m--margin-top-10 m--margin-bottom-40">
                        <thead>
                        <tr class="fixed-head-oline">
                          <th class="text-center fixed-number-width">№</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.name' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.amount' | transloco }}</th>
                          <th class="text-center fixed-head-one">{{ 'revenue-report.table.head.total' | transloco }}</th>
                        </tr>
                        </thead>
                        <tbody class="tbody-fixed">
                        <ng-container *ngFor="let even = even;let i = index; let p of listOthersValue">
                          <tr>
                            <td>{{ i }}</td>
                            <td>{{ p.productInfoTitle | uiLabel }}</td>
                            <td class="text-align-center">{{ p.totalCount }}</td>
                            <td class="text-align-center">{{ p.totalValue }}</td>
                          </tr>
                        </ng-container>
                        <tr class="font-weight-bold">
                          <td class="text-center" colspan="2">{{ 'revenue-report.table.head.total' | transloco }}</td>
                          <td class="text-align-center">{{ totalOthersCount }}</td>
                          <td class="text-align-center">{{ totalOthersValue }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <hx-loader [length]="listCategory.length" [isLoading]="isLoading.category"></hx-loader>
                    <hx-loader [length]="listStandardAndMaxCakesCount.length" [isLoading]="isLoading.product"></hx-loader>
                  </ng-template>
                </li>
              </ul>
            </div>
            <div [ngbNavOutlet]="nav"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
